import { Text } from '@shared/components/Text';
import { Colors } from '@shared/styles';
import { API } from '@shared/types/api';
import { i18n } from '@shared/util/i18n';
import { formatNameList } from '@shared/util/name';
import { MBBaseChatBanner } from './base';

interface MBMultiDMChatBannerProps {
  users: API.ShortUserFragment[];
  channel: API.ChannelFragment;
}

export function MBMultiDMChatBanner({ users, channel }: MBMultiDMChatBannerProps) {
  const title = formatNameList(users.map(u => u.fullName));
  const subtitle = users.map(u => `@${u.username}`).join(', ');
  return (
    <MBBaseChatBanner title={title} subtitle={subtitle} channel={channel}>
      <Text color={Colors.v2.greenSecondary90}>{i18n('chat.banner.dm', { name: title })}</Text>
    </MBBaseChatBanner>
  );
}
